<template>
  <b-button
    :block="block"
    :disabled="disabled"
    :type="type"
    :variant="variant"
    :pill="pill"
    :size="size"
    @click="click"
  >
    <span v-if="loading" class="loading-part">
      <b-spinner small type="grow" class="ml-2"></b-spinner>
      لطفا شکیبا باشید...
    </span>
    <span v-else><slot></slot></span>
  </b-button>
</template>

<script>
export default {
  name: "LoadingBtn",
  props: {
    size: {
      type: String,
      default: "md"
    },
    loading: {
      type: Boolean,
      required: true
    },
    block: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    pill: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "button"
    },
    variant: {
      type: String,
      default: "primary"
    }
  },
  methods: {
    click: function() {
      this.$emit("click");
    }
  }
};
</script>

<style>
.loading-part {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
